export const priceCalculationLabels = {
    de: {
        title: 'Preisgestaltung',
        description: 'Aus Kosten nachvollziehbare Verkaufspreise kalkulieren, vergleichen und für einen festen Zeitraum freigeben.',
        help: 'Hilfe zur Preisgestaltung',
        builder: 'Kalkulationsbaukasten',
        templates: 'Vorlagen',
        templatesHint: 'Wiederverwendbare Schritte und Gruppenregeln; Änderungen erzeugen erst nach Simulation und Freigabe neue Preise.',
        template: 'Kalkulationsvorlage',
        addTemplate: 'Vorlage anlegen',
        noTemplates: 'Noch keine Vorlage. Legen Sie die erste Kalkulationsvorlage an.',
        sampleCost: 'Beispiel: Ausgangskosten je Einheit',
        sampleHint: 'Dieses Rechenbeispiel speichert keine Artikelkosten und keine Verkaufspreise.',
        sampleResult: 'Beispiel: Basisverkaufspreis',
        calculationQuantity: 'Kalkulations- und Prüfmenge',
        stepLabel: 'Bezeichnung des Rechenschritts',
        addStep: 'Rechenschritt hinzufügen',
        removeStep: 'Rechenschritt entfernen',
        newStep: 'Neuer Rechenschritt',
        moveUp: 'Nach oben',
        moveDown: 'Nach unten',
        active: 'Aktiv',
        inactive: 'Inaktiv',
        operation: 'Zu- oder Abschlag',
        ADD: 'Zuschlag',
        SUBTRACT: 'Abschlag / Rabatt',
        valueType: 'Art des Werts',
        percent: 'Prozentwert',
        fixed: 'Fester Geldbetrag',
        value: 'Wert',
        basis: 'Berechnungsgrundlage',
        ORIGINAL: 'Ursprüngliche Ausgangskosten',
        SUBTOTAL: 'Bisherige Zwischensumme',
        STEP: 'Benannte vorherige Zwischensumme',
        referenceStep: 'Vorheriger Rechenschritt',
        fixedBasis: 'Bezugsmenge des Festbetrags',
        perUnit: 'Je einer Einheit',
        perBatch: 'Gesamtbetrag einer Menge / Charge',
        fixedQuantity: 'Feste Kalkulationsmenge',
        fixedQuantityHint: 'Leer: ausdrücklich eingestellte Kalkulationsmenge. 70 € für 100 Stück = 0,70 € je Stück.',
        unit: 'Einheit',
        unitHint: 'Leer: Basiseinheit je Artikel. Abweichungen benötigen ein ausdrücklich ausgewähltes Gebinde.',
        advanced: 'Erweiterte Einstellungen',
        centralVariable: 'Zentral gepflegter Wert',
        ownValue: 'Eigener Wert dieses Schritts',
        costComponent: 'Kennung des Kostenbestandteils',
        costComponentHint: 'Zum Beispiel transport. Dieselbe Kennung in der Kostenquelle warnt vor doppelter Berücksichtigung.',
        of: 'von',
        subtotal: 'Zwischensumme',
        profitMethod: 'Gewinnverfahren',
        MARKUP: 'Gewinnaufschlag auf Kosten',
        MARGIN: 'Zielmarge am Nettoverkaufspreis',
        markupExample: '100 € Kosten + 25 % Gewinnaufschlag = 125 € netto. Die Marge beträgt 20 %.',
        marginExample: '100 € Kosten / (1 − 25 % Zielmarge) = 133,3333 € netto. Zielmarge muss unter 100 % liegen.',
        profitPercent: 'Gewinnaufschlag / Zielmarge in %',
        minimumAfterGroups: 'Zielmarge auch nach Gruppen- und ausgewähltem Kundenrabatt mindestens erreichen',
        variables: 'Zentrale Werte',
        variableKey: 'Stabile Kennung',
        newVariable: 'Neuer zentraler Wert',
        addVariable: 'Zentralen Wert hinzufügen',
        name: 'Name',
        version: 'Version',
        copy: 'Kopie',
        saved: 'Gespeichert. Wirksame Preise bleiben bis zur Freigabe unverändert.',
        saveError: 'Die Änderung konnte nicht gespeichert werden. Eingaben bleiben erhalten.',
        loadError: 'Daten konnten nicht geladen werden. Bitte erneut versuchen.',
        choose: 'Bitte auswählen',
        groupRules: 'Preisgruppen: Rabatte und Zuschläge',
        independentGroups: 'Jede Gruppe wird einzeln aus dem Basispreis berechnet. Gruppenrabatte werden nicht verkettet.',
        productSearch: 'Artikel suchen',
        selectedProduct: 'Ausgewählter Artikel',
        noProducts: 'Keine passenden Artikel.',
        customerSearch: 'Kunden suchen',
        customer: 'Kundenkonditionen prüfen',
        noCustomer: 'Ohne zusätzlichen Kundenrabatt',
        overrideHint: 'Nur aktivierte Abweichungen überschreiben geerbte Werte.',
        inheritanceHint: 'Artikelvorgabe vor ausdrücklich bestimmter Preiskategorie vor globaler Vorgabe. Mehrdeutige Kategorien sperren die Kalkulation.',
        assignments: 'Zuordnung und Vorgaben',
        scope: 'Geltungsbereich',
        inherit: 'Geerbte Vorgabe verwenden',
        inheritPurchase: 'Vererben; sonst Einkaufspreis des Artikels',
        priceCategory: 'Preiskategorie (Artikelkategorie)',
        priceCategoryHint: 'Nur zugeordnete Artikelkategorien. Diese Auswahl löst mehrere passende Kategorien eindeutig auf.',
        automaticCategory: 'Eindeutige / primäre zugeordnete Kategorie',
        costSource: 'Kostenquelle',
        PRODUCT_PURCHASE: 'Einkaufspreis im Artikelstamm',
        ASSUMPTION: 'Bewusst eingegebene Kalkulationsannahme',
        RECIPE_VERSION: 'Freigegebene Rezepturversion: Materialkosten',
        recipeVersion: 'Freigegebene Rezepturversion',
        materialOnly: 'Rezepturwerte enthalten Materialkosten. Weitere Herstellungskosten ausdrücklich ergänzen und doppelte Kosten vermeiden.',
        includedCosts: 'Bereits enthaltene Kostenkennungen',
        includedCostsHint: 'Kommagetrennte Kennungen, zum Beispiel material, transport. Entsprechende Rechenschritte erhalten einen Doppelzählungshinweis.',
        valueOverrides: 'Zentrale Werte ausdrücklich überschreiben',
        groupOverrides: 'Gruppenregeln überschreiben',
        explicitOverride: 'Eigene Gruppenregeln für diesen Bereich verwenden',
        copyOverrides: 'Artikelabweichungen kopieren',
        scenarios: 'Simulation und Vergleich',
        scenarioName: 'Name des Szenarios',
        simulationHint: 'Simulationen ändern keine wirksamen Preise. Erst die geprüfte Freigabe plant neue Preisversionen.',
        newScenario: 'Neues Szenario',
        noScenarios: 'Noch keine Szenarien. Wählen Sie Artikel und berechnen Sie einen Vorschlag.',
        selection: 'Artikelauswahl',
        selectedProducts: 'Einzelne oder ausgewählte Artikel',
        filteredAssortment: 'Gefiltertes Sortiment',
        useAssignment: 'Zugeordnete / geerbte Vorlage verwenden',
        exactCategoryHint: 'Artikel dieser Kategorie; Unterkategorien werden nicht automatisch einbezogen.',
        productGroup: 'Artikelgruppe',
        tags: 'Schlagwörter (kommagetrennt)',
        referenceDate: 'Stichtag für bisherige Konditionen',
        currency: 'Währung',
        packaging: 'Einheit / Gebinde',
        validFrom: 'Gültig ab',
        validTo: 'Gültig bis (einschließlich)',
        groupPrices: 'Gruppenpreise',
        includeBase: 'Basispreis als allgemeine Kondition übernehmen',
        minQuantity: 'Staffel ab Menge in Basiseinheit',
        tierHint: '0 gilt auch für Teilmengen. Vorhandene höhere Mengenstaffeln und Kundenpreise haben weiterhin Vorrang.',
        activeOnly: 'Nur aktive Artikel',
        periodConflicts: 'Umgang mit gleichen, überlappenden Konditionen',
        periodConflictHint: 'Ersetzen wird vor Freigabe angezeigt. Alte Zeiträume werden begrenzt oder geteilt; Belegpreise bleiben erhalten.',
        REJECT: 'Konflikte ausschließen',
        REPLACE: 'Gleiche Konditionen im neuen Zeitraum ausdrücklich ersetzen',
        profitOverride: 'Gewinnvorgabe nur in diesem Szenario ändern',
        schedule: 'Abweichende Start- und Endtermine',
        addSchedule: 'Abweichenden Zeitraum hinzufügen',
        group: 'Preisgruppe',
        target: 'Artikel / Kategorie / Gruppe',
        saveScenario: 'Szenario speichern',
        simulate: 'Berechnen und vergleichen',
        calculating: 'Berechnung läuft …',
        simulated: 'Vorschau berechnet. Es wurden keine wirksamen Preise geändert.',
        approvedLocked: 'Dieser Stand ist freigegeben. Für Änderungen das Szenario kopieren.',
        comparison: 'Preisvergleich',
        noPreview: 'Noch keine Vorschau. Das Szenario berechnen, um Preise und Hinweise zu prüfen.',
        previewSummary: '{{eligible}} Artikel übernehmbar · {{excluded}} ausgeschlossen',
        comparisonHint: 'Alle Preise netto je Basiseinheit. Neue Konditionen werden am jeweiligen Starttag geprüft. Der tatsächliche Preis berücksichtigt Staffeln, Kundenpreise und den einmaligen zusätzlichen Kundenrabatt einschließlich Belegzeilenrundung für die Prüfmenge.',
        export: 'Preisvergleich exportieren',
        exportInternal: 'Intern mit Kosten und Margen exportieren',
        reviewApproval: 'Übernahme prüfen',
        article: 'Artikel',
        oldPrice: 'Bisheriger Preis',
        basePrice: 'Basisverkaufspreis',
        change: 'Änderung',
        actualMargin: 'Tatsächliche Marge',
        excluded: 'Ausgeschlossen',
        breakdown: 'Berechnung und Hinweise öffnen',
        limitingGroup: 'Begrenzender Gruppenrabatt für die Mindestmarge',
        actualPrice: 'Tatsächlicher Preis nach Kundenrabatt',
        conditionSource: 'Wirksame Kondition',
        costs: 'Kalkulierte Kosten',
        difference: 'Differenz zu kalkulierten Kosten',
        openEnded: 'Ohne Enddatum',
        warning: 'Hinweis prüfen',
        approvalTitle: 'Geprüfte Preisversionen freigeben',
        approvalHint: 'Prüfen Sie Artikel, Gruppen, alte und neue Preise, Gültigkeit und Ausschlüsse. Freigegebene Preise ändern sich danach nicht durch neue Kosten.',
        approvalCount: '{{count}} Artikel freigeben · {{excluded}} ausgeschlossen',
        acknowledge: 'Preise, Gültigkeit, Warnungen und ausgeschlossene Artikel geprüft',
        approve: 'Preisversionen verbindlich freigeben',
        approving: 'Freigabe läuft …',
        approved: 'Preisversionen freigegeben. Sie gelten automatisch im festgelegten Zeitraum.',
        versions: 'Preisversionen',
        noVersions: 'Noch keine freigegebenen Preisversionen.',
        frozenVersion: 'Festgehaltener Freigabestand. Die ursprünglichen Zeiträume bleiben hier nachvollziehbar; spätere Freigaben können die wirksamen Zeiträume begrenzen.',
        managedPricesHint: 'Freigegebene Kalkulationspreise werden separat als Preisversionen verwaltet und bei diesem Speichern beibehalten.',
        origin: {
            GLOBAL: 'Globaler Standard',
            CATEGORY: 'Preiskategorie',
            PRODUCT: 'Artikelvorgabe',
            TEMPLATE: 'Vorlagenwert',
            SCENARIO: 'Szenarioabweichung',
            MIXED: 'Unterschiedliche geerbte Vorgaben – eigenen Wert eingeben',
        },
        states: {
            DRAFT: 'Entwurf',
            APPROVED: 'Freigegeben',
            PLANNED: 'Geplant',
            EFFECTIVE: 'Wirksam',
            EXPIRED: 'Abgelaufen / ersetzt',
        },
        sources: {
            CUSTOMER: 'Kunden-Sonderpreis',
            GROUP: 'Preisgruppenstaffel',
            GENERAL: 'Allgemeine Staffel',
            LIST: 'Listenpreis',
        },
        costFields: {
            amount: 'Nettokosten je Einheit',
            unitCode: 'Kosteneinheit',
            currency: 'Kostenwährung',
            asOf: 'Kostenstand vom',
            source: 'Quelle / Begründung der Annahme',
        },
        errors: {
            invalidInput: 'Bitte Bezeichnung, Dezimalwerte, Grundlagen und Pflichtangaben prüfen.',
            costRequired: 'Keine vollständigen bekannten Kosten vorhanden. Kostenquelle oder bewusste Annahme ergänzen.',
            unitMismatch: 'Einheiten passen nicht zusammen. Basiseinheit oder ausdrücklich vorhandenes Gebinde verwenden.',
            currencyMismatch: 'Die Währungen stimmen nicht überein. Es erfolgt keine automatische Umrechnung.',
            quantityRequired: 'Für den Gesamtbetrag fehlt eine passende Kalkulationsmenge.',
            invalidReference: 'Als Grundlage ist nur eine aktive vorherige Zwischensumme zulässig. Reihenfolge prüfen.',
            invalidMargin: 'Die Zielmarge muss mindestens 0 % und kleiner als 100 % sein.',
            negativeResult: 'Ein Rechenschritt erzeugt negative Kosten oder einen negativen Preis.',
            overflow: 'Der berechnete Betrag überschreitet den zulässigen Preisbereich.',
            impossibleMargin: 'Die Mindestmarge ist mit diesen Rabatten nicht erreichbar. Rabatte und Zielmarge prüfen.',
            duplicate: 'Eine Kennung, Gruppe oder Bereichszuordnung kommt mehrfach vor.',
            unknownVariable: 'Ein zentraler Wert fehlt in der wirksamen Vorlage. Zuordnung oder Überschreibung prüfen.',
            invalidDate: 'Bitte ein gültiges Kalenderdatum eingeben.',
            invalidScope: 'Geltungsbereich und Zuordnung passen nicht zusammen.',
            validity: 'Das Enddatum darf nicht vor dem Startdatum liegen.',
            groupsRequired: 'Mindestens Basispreis oder eine Preisgruppe auswählen.',
            singlePackaging: 'Ein Gebinde kann nur für einen einzeln ausgewählten Artikel geprüft werden.',
            notFound: 'Die ausgewählte Vorlage, Zuordnung oder Stammdatenreferenz wurde nicht gefunden.',
            inactiveGroup: 'Eine ausgewählte Preisgruppe ist inaktiv oder noch nicht geprüft.',
            productReview: 'Dieser Artikel muss vor Verwendung kaufmännisch geprüft werden.',
            categoryAssignment: 'Die gewählte Preiskategorie ist diesem Artikel nicht zugeordnet.',
            ambiguousCategory: 'Mehrere passende Preiskategorien: eine Preiskategorie am Artikel ausdrücklich auswählen.',
            definitionRequired: 'Keine vollständige Kalkulationsvorlage vorhanden.',
            groupRuleRequired: 'Für eine ausgewählte Preisgruppe fehlt eine ausdrückliche Rabatt- oder Zuschlagsregel.',
            recipeRequired: 'Eine passende, vollständige und am Stichtag freigegebene Rezepturversion auswählen.',
            recipePermission: 'Für diese Kostenquelle werden zusätzliche Rezeptur- und Kostenrechte benötigt.',
            futureCost: 'Der Kostenstand liegt nach dem gewählten Stichtag.',
            quantityStep: 'Die Prüfmenge erfüllt Mindestmenge oder Mengenschritt des Gebindes nicht.',
            overlap: 'Gleiche Preisbedingungen überlappen. Startdatum ändern oder Ersetzen ausdrücklich auswählen.',
            minimumMargin: 'Die tatsächlich wirksame Kondition unterschreitet die Mindestmarge. Mengenstaffeln, Kundenpreise und Rundung prüfen.',
            versionConflict: 'Die Daten wurden inzwischen geändert. Neu laden und eigene Änderungen erneut prüfen.',
            stalePreview: 'Die Vorschau ist veraltet. Kosten, Vorlage oder Konditionen haben sich geändert. Erneut berechnen.',
            idempotencyConflict: 'Diese Übernahme wurde bereits mit anderen Angaben ausgeführt.',
            incomplete: 'Unvollständige Berechnung. Diese Artikel können nicht als gültige Preise übernommen werden.',
            invalidSelection: 'Die Auswahl passt nicht zu dieser geprüften Vorschau.',
            acknowledgeWarnings: 'Hinweise und Warnungen vor der Freigabe ausdrücklich bestätigen.',
            managedPrice: 'Dieser Preis gehört zu einer freigegebenen Version. Änderungen über eine neue Kalkulation freigeben.',
            managedUnit: 'Die Basiseinheit ist durch freigegebene Preisversionen geschützt und darf nicht umgedeutet werden.',
            immutableRelease: 'Ein freigegebener Berechnungsstand kann nicht geändert oder gelöscht werden.',
            noProducts: 'Keine Artikel für diese Auswahl gefunden.',
            tooManyProducts: 'Die Auswahl umfasst mehr als 200 Artikel. Filter einschränken und in geprüften Teilmengen arbeiten.',
            templateRequired: 'Keine vollständige Kalkulationsvorlage vorhanden.',
            customerConditionsRequired: 'Der Kundenrabatt ist noch ungeklärt. Kundenkonditionen vor dieser Simulation prüfen.',
            priceUnresolved: 'Für die Prüfmenge, Währung und Kundengruppe ist kein gültiger Preis auflösbar. Auswahl, Staffel und Menge prüfen.',
        },
        warnings: {
            duplicateCost: 'Dieser Bestandteil ist möglicherweise schon in den Ausgangskosten enthalten.',
            largeChange: 'Ungewöhnlich große Preisänderung über 30 %. Bitte prüfen.',
            materialOnly: 'Rezepturwerte enthalten Materialkosten. Weitere Herstellungskosten ausdrücklich ergänzen und doppelte Kosten vermeiden.',
            minimumMargin: 'Die tatsächlich wirksame Kondition unterschreitet die Mindestmarge. Mengenstaffeln, Kundenpreise und Rundung prüfen.',
            oldCost: 'Kostenstand älter als 90 Tage. Aktualität vor Freigabe prüfen.',
            overridden: 'Eine vorhandene höher priorisierte Kondition bestimmt den tatsächlichen Preis.',
            replacesPeriods: 'Gleiche Konditionen werden für den neuen Zeitraum begrenzt oder geteilt.',
            costDateUnknown: 'Für diesen bisherigen Einkaufspreis ist kein eigener Kostenstand gespeichert. Angezeigt wird der Artikelstand; Aktualität ausdrücklich prüfen.',
            unusedVariable: 'Dieser geerbte Wert wird von der wirksamen Vorlage nicht verwendet.',
            periodAdjusted: 'Ein bisheriges Enddatum liegt in der Vergangenheit. Der neue Vorschlag hat dort noch kein Enddatum; Gültigkeit vor Freigabe ausdrücklich prüfen.',
            previousZero: 'Der bisherige Preis beträgt 0. Die prozentuale Änderung ist nicht berechenbar; neuen Preis ausdrücklich prüfen.',
        },
        remove: 'Entfernen',
        approvedBy: 'Freigegeben von',
        actualValidity: 'Aktuelle Teilzeiträume',
        superseded: 'Vollständig ersetzt',
        newProposal: 'Neuen Vorschlag berechnen',
        newProposalHint: 'Kosten oder Kalkulationsvorgaben haben sich geändert. Die freigegebenen Preise bleiben erhalten; ein neuer Vorschlag kann geprüft werden.',
        customerPrice: 'Tatsächliche Kundengruppe',
        calculatedPrice: 'Kalkulierter Vorschlagspreis',
        status: 'Prüfstatus',
        eligible: 'Übernehmbar',
        variableScopeHint: 'Bei einer Artikelauswahl werden geerbte Werte angezeigt. Bei unterschiedlichen Vorlagen stehen nur gemeinsame Variablen zur Verfügung; den konkreten Stand zeigt die Berechnung je Artikel.',
        replacedConditions: 'Betroffene bisherige Preiskonditionen',
        previousPeriod: 'Bisheriger Zeitraum',
        remainingPeriods: 'Verbleibende Zeiträume',
        none: 'Keine',
        discount: 'Staffelrabatt',
        resolvedPrice: 'Wirksamer Konditionspreis',
    },
    en: {
        title: 'Price calculation',
        description: 'Calculate, compare and approve traceable selling prices from costs for a defined period.',
        help: 'Pricing help',
        builder: 'Calculation builder',
        templates: 'Templates',
        templatesHint: 'Reusable steps and group rules; changes produce new prices only after simulation and approval.',
        template: 'Calculation template',
        addTemplate: 'Create template',
        noTemplates: 'No templates yet. Create your first calculation template.',
        sampleCost: 'Example: initial cost per unit',
        sampleHint: 'This example saves neither product costs nor selling prices.',
        sampleResult: 'Example: base selling price',
        calculationQuantity: 'Calculation and test quantity',
        stepLabel: 'Calculation step name',
        addStep: 'Add calculation step',
        removeStep: 'Remove calculation step',
        newStep: 'New calculation step',
        moveUp: 'Move up',
        moveDown: 'Move down',
        active: 'Active',
        inactive: 'Inactive',
        operation: 'Surcharge or deduction',
        ADD: 'Surcharge',
        SUBTRACT: 'Deduction / discount',
        valueType: 'Value type',
        percent: 'Percentage',
        fixed: 'Fixed amount',
        value: 'Value',
        basis: 'Calculation basis',
        ORIGINAL: 'Original initial costs',
        SUBTOTAL: 'Current subtotal',
        STEP: 'Named preceding subtotal',
        referenceStep: 'Preceding calculation step',
        fixedBasis: 'Fixed amount basis',
        perUnit: 'Per one unit',
        perBatch: 'Total for a quantity / batch',
        fixedQuantity: 'Fixed calculation quantity',
        fixedQuantityHint: 'Blank: the chosen calculation quantity. €70 for 100 units = €0.70 per unit.',
        unit: 'Unit',
        unitHint: 'Blank: each product’s base unit. A different unit requires an explicitly selected packaging.',
        advanced: 'Advanced settings',
        centralVariable: 'Centrally maintained value',
        ownValue: 'This step’s own value',
        costComponent: 'Cost component key',
        costComponentHint: 'For example transport. The same key in the cost source warns about double counting.',
        of: 'of',
        subtotal: 'Subtotal',
        profitMethod: 'Profit method',
        MARKUP: 'Markup on costs',
        MARGIN: 'Target margin on net selling price',
        markupExample: '€100 costs + 25% markup = €125 net. The margin is 20%.',
        marginExample: '€100 costs / (1 − 25% target margin) = €133.3333 net. Target margin must be below 100%.',
        profitPercent: 'Markup / target margin in %',
        minimumAfterGroups: 'Keep at least the target margin after group and selected customer discounts',
        variables: 'Central values',
        variableKey: 'Stable key',
        newVariable: 'New central value',
        addVariable: 'Add central value',
        name: 'Name',
        version: 'Version',
        copy: 'Copy',
        saved: 'Saved. Effective prices stay unchanged until approval.',
        saveError: 'Could not save the change. Your input is retained.',
        loadError: 'Could not load data. Please retry.',
        choose: 'Please select',
        groupRules: 'Price groups: discounts and surcharges',
        independentGroups: 'Each group is calculated independently from the base price. Group discounts do not cascade.',
        productSearch: 'Search products',
        selectedProduct: 'Selected product',
        noProducts: 'No matching products.',
        customerSearch: 'Search customers',
        customer: 'Check customer conditions',
        noCustomer: 'Without additional customer discount',
        overrideHint: 'Only enabled overrides replace inherited values.',
        inheritanceHint: 'Product override before the explicitly determined price category before global defaults. Ambiguous categories block calculation.',
        assignments: 'Assignments and defaults',
        scope: 'Scope',
        inherit: 'Use inherited default',
        inheritPurchase: 'Inherit; otherwise product purchase price',
        priceCategory: 'Price category (product category)',
        priceCategoryHint: 'Assigned product categories only. This selection resolves multiple matching categories explicitly.',
        automaticCategory: 'Unambiguous / primary assigned category',
        costSource: 'Cost source',
        PRODUCT_PURCHASE: 'Product master purchase price',
        ASSUMPTION: 'Explicit calculation assumption',
        RECIPE_VERSION: 'Approved recipe version: material costs',
        recipeVersion: 'Approved recipe version',
        materialOnly: 'Recipe values contain material costs. Add other manufacturing costs explicitly and avoid double counting.',
        includedCosts: 'Already included cost keys',
        includedCostsHint: 'Comma-separated keys such as material, transport. Matching steps receive a double-counting warning.',
        valueOverrides: 'Explicitly override central values',
        groupOverrides: 'Override group rules',
        explicitOverride: 'Use own group rules for this scope',
        copyOverrides: 'Copy product overrides',
        scenarios: 'Simulation and comparison',
        scenarioName: 'Scenario name',
        simulationHint: 'Simulations do not change effective prices. Only reviewed approval schedules new price versions.',
        newScenario: 'New scenario',
        noScenarios: 'No scenarios yet. Select products and calculate a proposal.',
        selection: 'Product selection',
        selectedProducts: 'Single or selected products',
        filteredAssortment: 'Filtered assortment',
        useAssignment: 'Use assigned / inherited template',
        exactCategoryHint: 'Products in this category; subcategories are not included automatically.',
        productGroup: 'Product group',
        tags: 'Tags (comma-separated)',
        referenceDate: 'Reference date for existing conditions',
        currency: 'Currency',
        packaging: 'Unit / packaging',
        validFrom: 'Valid from',
        validTo: 'Valid until (inclusive)',
        groupPrices: 'Group prices',
        includeBase: 'Apply base price as a general condition',
        minQuantity: 'Tier from quantity in base units',
        tierHint: '0 also covers fractional quantities. Existing higher quantity tiers and customer prices retain priority.',
        activeOnly: 'Active products only',
        periodConflicts: 'Handling identical overlapping conditions',
        periodConflictHint: 'Replacement is shown before approval. Old periods are limited or split; document prices are retained.',
        REJECT: 'Exclude conflicts',
        REPLACE: 'Explicitly replace identical conditions in the new period',
        profitOverride: 'Change profit target only in this scenario',
        schedule: 'Different start and end dates',
        addSchedule: 'Add different period',
        group: 'Price group',
        target: 'Product / category / group',
        saveScenario: 'Save scenario',
        simulate: 'Calculate and compare',
        calculating: 'Calculating …',
        simulated: 'Preview calculated. No effective prices were changed.',
        approvedLocked: 'This version is approved. Copy the scenario to make changes.',
        comparison: 'Price comparison',
        noPreview: 'No preview yet. Calculate the scenario to check prices and notices.',
        previewSummary: '{{eligible}} products eligible · {{excluded}} excluded',
        comparisonHint: 'All prices are net per base unit. New conditions are checked on their start date. Actual price includes tiers, customer prices and one additional customer discount, including document-line rounding for the test quantity.',
        export: 'Export price comparison',
        exportInternal: 'Export internally with costs and margins',
        reviewApproval: 'Review adoption',
        article: 'Product',
        oldPrice: 'Previous price',
        basePrice: 'Base selling price',
        change: 'Change',
        actualMargin: 'Actual margin',
        excluded: 'Excluded',
        breakdown: 'Open calculation and notices',
        limitingGroup: 'Limiting group discount for minimum margin',
        actualPrice: 'Actual price after customer discount',
        conditionSource: 'Effective condition',
        costs: 'Calculated costs',
        difference: 'Difference from calculated costs',
        openEnded: 'No end date',
        warning: 'Review notice',
        approvalTitle: 'Approve reviewed price versions',
        approvalHint: 'Review products, groups, old and new prices, validity and exclusions. Approved prices will not change with later costs.',
        approvalCount: 'Approve {{count}} products · {{excluded}} excluded',
        acknowledge: 'Prices, validity, warnings and excluded products reviewed',
        approve: 'Approve binding price versions',
        approving: 'Approving …',
        approved: 'Price versions approved. They apply automatically within the defined period.',
        versions: 'Price versions',
        noVersions: 'No approved price versions yet.',
        frozenVersion: 'Frozen approval record. Original periods remain traceable here; later approvals may limit effective periods.',
        managedPricesHint: 'Approved calculated prices are managed separately as price versions and retained when saving here.',
        origin: {
            GLOBAL: 'Global default',
            CATEGORY: 'Price category',
            PRODUCT: 'Product override',
            TEMPLATE: 'Template value',
            SCENARIO: 'Scenario override',
            MIXED: 'Different inherited defaults – enter an explicit value',
        },
        states: {
            DRAFT: 'Draft',
            APPROVED: 'Approved',
            PLANNED: 'Planned',
            EFFECTIVE: 'Effective',
            EXPIRED: 'Expired / replaced',
        },
        sources: {
            CUSTOMER: 'Customer special price',
            GROUP: 'Price group tier',
            GENERAL: 'General tier',
            LIST: 'List price',
        },
        costFields: {
            amount: 'Net cost per unit',
            unitCode: 'Cost unit',
            currency: 'Cost currency',
            asOf: 'Cost date',
            source: 'Source / assumption rationale',
        },
        errors: {
            invalidInput: 'Check names, decimal values, bases and required fields.',
            costRequired: 'Complete known costs are missing. Add a cost source or explicit assumption.',
            unitMismatch: 'Units do not match. Use the base unit or explicitly existing packaging.',
            currencyMismatch: 'Currencies do not match. There is no automatic conversion.',
            quantityRequired: 'A matching calculation quantity is required for the total amount.',
            invalidReference: 'Only an active preceding subtotal may be used as a basis. Check the order.',
            invalidMargin: 'Target margin must be at least 0% and below 100%.',
            negativeResult: 'A calculation step produces negative costs or a negative price.',
            overflow: 'The calculated amount exceeds the allowed price range.',
            impossibleMargin: 'The minimum margin cannot be achieved with these discounts. Check discounts and target margin.',
            duplicate: 'A key, group or scope assignment occurs more than once.',
            unknownVariable: 'A central value is missing from the effective template. Check assignment or overrides.',
            invalidDate: 'Enter a valid calendar date.',
            invalidScope: 'Scope and assignment do not match.',
            validity: 'The end date must not precede the start date.',
            groupsRequired: 'Select at least the base price or one price group.',
            singlePackaging: 'Packaging can only be checked for one individually selected product.',
            notFound: 'The selected template, assignment or master data reference was not found.',
            inactiveGroup: 'A selected price group is inactive or not yet reviewed.',
            productReview: 'This product needs commercial review before use.',
            categoryAssignment: 'The selected price category is not assigned to this product.',
            ambiguousCategory: 'Multiple matching price categories: explicitly select one on the product.',
            definitionRequired: 'No complete calculation template exists.',
            groupRuleRequired: 'A selected price group has no explicit discount or surcharge rule.',
            recipeRequired: 'Select a matching, complete recipe version approved on the reference date.',
            recipePermission: 'This cost source requires additional recipe and cost permissions.',
            futureCost: 'The cost date is later than the selected reference date.',
            quantityStep: 'The test quantity does not meet the packaging minimum or quantity step.',
            overlap: 'Identical price conditions overlap. Change the start date or explicitly choose replacement.',
            minimumMargin: 'The effective condition falls below minimum margin. Check tiers, customer prices and rounding.',
            versionConflict: 'The data has changed. Reload and review your changes again.',
            stalePreview: 'The preview is stale. Costs, template or conditions changed. Recalculate.',
            idempotencyConflict: 'This adoption was already executed with different details.',
            incomplete: 'Incomplete calculation. These products cannot be adopted as valid prices.',
            invalidSelection: 'The selection does not match this reviewed preview.',
            acknowledgeWarnings: 'Explicitly acknowledge notices and warnings before approval.',
            managedPrice: 'This price belongs to an approved version. Approve changes through a new calculation.',
            managedUnit: 'Approved price versions protect the base unit against reinterpretation.',
            immutableRelease: 'An approved calculation record cannot be changed or deleted.',
            noProducts: 'No products found for this selection.',
            tooManyProducts: 'The selection exceeds 200 products. Narrow filters and use reviewed subsets.',
            templateRequired: 'No complete calculation template exists.',
            customerConditionsRequired: 'The customer discount is unresolved. Review customer conditions before this simulation.',
            priceUnresolved: 'No valid price can be resolved for this test quantity, currency and customer group. Check selection, tier and quantity.',
        },
        warnings: {
            duplicateCost: 'This component may already be included in the initial costs.',
            largeChange: 'Unusually large price change above 30%. Please review.',
            materialOnly: 'Recipe values contain material costs. Add other manufacturing costs explicitly and avoid double counting.',
            minimumMargin: 'The effective condition falls below minimum margin. Check tiers, customer prices and rounding.',
            oldCost: 'Cost data is older than 90 days. Check freshness before approval.',
            overridden: 'An existing higher-priority condition determines the actual price.',
            replacesPeriods: 'Identical conditions will be limited or split for the new period.',
            costDateUnknown: 'This legacy purchase price has no dedicated cost date. The product update date is shown; explicitly check freshness.',
            unusedVariable: 'This inherited value is not used by the effective template.',
            periodAdjusted: 'A previous end date is in the past. That part of the new proposal has no end date yet; explicitly review validity before approval.',
            previousZero: 'The previous price is 0. The percentage change cannot be calculated; explicitly review the new price.',
        },
        remove: 'Remove',
        approvedBy: 'Approved by',
        actualValidity: 'Current interval fragments',
        superseded: 'Fully replaced',
        newProposal: 'Calculate a new proposal',
        newProposalHint: 'Costs or calculation defaults changed. Approved prices are retained; a new proposal is available for review.',
        customerPrice: 'Actual customer group',
        calculatedPrice: 'Calculated proposed price',
        status: 'Review status',
        eligible: 'Eligible',
        variableScopeHint: 'Inherited values are shown for an individual product. Mixed templates offer only common variables; the calculation shows each product’s exact defaults.',
        replacedConditions: 'Affected existing price conditions',
        previousPeriod: 'Previous period',
        remainingPeriods: 'Remaining periods',
        none: 'None',
        discount: 'Tier discount',
        resolvedPrice: 'Effective condition price',
    },
    tr: {
        title: 'Fiyat hesaplama',
        description: 'Maliyetlerden izlenebilir satış fiyatları hesaplayın, karşılaştırın ve belirli dönemler için onaylayın.',
        help: 'Fiyatlandırma yardımı',
        builder: 'Hesaplama aracı',
        templates: 'Şablonlar',
        templatesHint: 'Yeniden kullanılabilir adımlar ve grup kuralları; değişiklikler ancak simülasyon ve onay sonrasında yeni fiyat oluşturur.',
        template: 'Hesaplama şablonu',
        addTemplate: 'Şablon oluştur',
        noTemplates: 'Henüz şablon yok. İlk hesaplama şablonunuzu oluşturun.',
        sampleCost: 'Örnek: birim başına başlangıç maliyeti',
        sampleHint: 'Bu örnek ürün maliyetlerini veya satış fiyatlarını kaydetmez.',
        sampleResult: 'Örnek: temel satış fiyatı',
        calculationQuantity: 'Hesaplama ve kontrol miktarı',
        stepLabel: 'Hesaplama adımının adı',
        addStep: 'Hesaplama adımı ekle',
        removeStep: 'Hesaplama adımını kaldır',
        newStep: 'Yeni hesaplama adımı',
        moveUp: 'Yukarı taşı',
        moveDown: 'Aşağı taşı',
        active: 'Etkin',
        inactive: 'Devre dışı',
        operation: 'Artış veya indirim',
        ADD: 'Artış',
        SUBTRACT: 'İndirim / iskonto',
        valueType: 'Değer türü',
        percent: 'Yüzde',
        fixed: 'Sabit tutar',
        value: 'Değer',
        basis: 'Hesaplama temeli',
        ORIGINAL: 'İlk başlangıç maliyetleri',
        SUBTOTAL: 'Mevcut ara toplam',
        STEP: 'Adlandırılmış önceki ara toplam',
        referenceStep: 'Önceki hesaplama adımı',
        fixedBasis: 'Sabit tutarın miktar temeli',
        perUnit: 'Birim başına',
        perBatch: 'Miktar / parti için toplam',
        fixedQuantity: 'Sabit hesaplama miktarı',
        fixedQuantityHint: 'Boş: seçilen hesaplama miktarı. 100 adet için 70 € = adet başına 0,70 €.',
        unit: 'Birim',
        unitHint: 'Boş: her ürünün temel birimi. Farklı birim için ambalaj açıkça seçilmelidir.',
        advanced: 'Gelişmiş ayarlar',
        centralVariable: 'Merkezi değer',
        ownValue: 'Bu adıma özgü değer',
        costComponent: 'Maliyet bileşeni anahtarı',
        costComponentHint: 'Örneğin transport. Maliyet kaynağında aynı anahtar varsa çift sayım uyarısı gösterilir.',
        of: 'üzerinden',
        subtotal: 'Ara toplam',
        profitMethod: 'Kâr yöntemi',
        MARKUP: 'Maliyet üzerine kâr ekleme',
        MARGIN: 'Net satış fiyatında hedef marj',
        markupExample: '100 € maliyet + %25 kâr ekleme = 125 € net. Marj %20’dir.',
        marginExample: '100 € maliyet / (1 − %25 hedef marj) = 133,3333 € net. Hedef marj %100’ün altında olmalıdır.',
        profitPercent: 'Kâr ekleme / hedef marj (%)',
        minimumAfterGroups: 'Grup ve seçilen müşteri indirimlerinden sonra en az hedef marjı koru',
        variables: 'Merkezi değerler',
        variableKey: 'Sabit anahtar',
        newVariable: 'Yeni merkezi değer',
        addVariable: 'Merkezi değer ekle',
        name: 'Ad',
        version: 'Sürüm',
        copy: 'Kopya',
        saved: 'Kaydedildi. Geçerli fiyatlar onaya kadar değişmez.',
        saveError: 'Değişiklik kaydedilemedi. Girdileriniz korunur.',
        loadError: 'Veriler yüklenemedi. Lütfen yeniden deneyin.',
        choose: 'Lütfen seçin',
        groupRules: 'Fiyat grupları: indirimler ve artışlar',
        independentGroups: 'Her grup temel fiyattan bağımsız hesaplanır. Grup indirimleri birbirine eklenmez.',
        productSearch: 'Ürün ara',
        selectedProduct: 'Seçili ürün',
        noProducts: 'Eşleşen ürün yok.',
        customerSearch: 'Müşteri ara',
        customer: 'Müşteri koşullarını kontrol et',
        noCustomer: 'Ek müşteri indirimi olmadan',
        overrideHint: 'Yalnızca etkinleştirilen istisnalar devralınan değerleri değiştirir.',
        inheritanceHint: 'Ürün ayarı, açıkça belirlenen fiyat kategorisinden; kategori de genel ayardan önceliklidir. Belirsiz kategoriler hesaplamayı engeller.',
        assignments: 'Atamalar ve varsayılanlar',
        scope: 'Kapsam',
        inherit: 'Devralınan ayarı kullan',
        inheritPurchase: 'Devral; yoksa ürünün alış fiyatı',
        priceCategory: 'Fiyat kategorisi (ürün kategorisi)',
        priceCategoryHint: 'Yalnızca atanmış ürün kategorileri. Bu seçim birden çok eşleşen kategoriyi açıkça çözümler.',
        automaticCategory: 'Tek anlamlı / birincil atanmış kategori',
        costSource: 'Maliyet kaynağı',
        PRODUCT_PURCHASE: 'Ürün ana verisindeki alış fiyatı',
        ASSUMPTION: 'Açıkça girilen hesaplama varsayımı',
        RECIPE_VERSION: 'Onaylı reçete sürümü: malzeme maliyetleri',
        recipeVersion: 'Onaylı reçete sürümü',
        materialOnly: 'Reçete değerleri malzeme maliyetlerini içerir. Diğer üretim maliyetlerini açıkça ekleyin ve çift sayımdan kaçının.',
        includedCosts: 'Zaten dahil olan maliyet anahtarları',
        includedCostsHint: 'Virgülle ayrılmış anahtarlar, örneğin material, transport. Eşleşen adımlarda çift sayım uyarısı gösterilir.',
        valueOverrides: 'Merkezi değerleri açıkça değiştir',
        groupOverrides: 'Grup kurallarını değiştir',
        explicitOverride: 'Bu kapsam için özel grup kuralları kullan',
        copyOverrides: 'Ürün istisnalarını kopyala',
        scenarios: 'Simülasyon ve karşılaştırma',
        scenarioName: 'Senaryo adı',
        simulationHint: 'Simülasyonlar geçerli fiyatları değiştirmez. Yeni fiyat sürümleri ancak incelenip onaylandıktan sonra planlanır.',
        newScenario: 'Yeni senaryo',
        noScenarios: 'Henüz senaryo yok. Ürünleri seçip bir öneri hesaplayın.',
        selection: 'Ürün seçimi',
        selectedProducts: 'Tek veya seçili ürünler',
        filteredAssortment: 'Filtrelenmiş ürün yelpazesi',
        useAssignment: 'Atanmış / devralınan şablonu kullan',
        exactCategoryHint: 'Bu kategorinin ürünleri; alt kategoriler otomatik dahil edilmez.',
        productGroup: 'Ürün grubu',
        tags: 'Etiketler (virgülle ayrılmış)',
        referenceDate: 'Mevcut koşullar için referans tarihi',
        currency: 'Para birimi',
        packaging: 'Birim / ambalaj',
        validFrom: 'Geçerlilik başlangıcı',
        validTo: 'Geçerlilik sonu (dahil)',
        groupPrices: 'Grup fiyatları',
        includeBase: 'Temel fiyatı genel koşul olarak uygula',
        minQuantity: 'Temel birimde kademe başlangıç miktarı',
        tierHint: '0, kesirli miktarları da kapsar. Mevcut yüksek miktar kademeleri ve müşteri fiyatları önceliğini korur.',
        activeOnly: 'Yalnızca etkin ürünler',
        periodConflicts: 'Aynı ve çakışan koşulların işlenmesi',
        periodConflictHint: 'Değiştirme onaydan önce gösterilir. Eski dönemler sınırlandırılır veya bölünür; belge fiyatları korunur.',
        REJECT: 'Çakışmaları dışla',
        REPLACE: 'Yeni dönemde aynı koşulları açıkça değiştir',
        profitOverride: 'Kâr hedefini yalnızca bu senaryoda değiştir',
        schedule: 'Farklı başlangıç ve bitiş tarihleri',
        addSchedule: 'Farklı dönem ekle',
        group: 'Fiyat grubu',
        target: 'Ürün / kategori / grup',
        saveScenario: 'Senaryoyu kaydet',
        simulate: 'Hesapla ve karşılaştır',
        calculating: 'Hesaplanıyor …',
        simulated: 'Önizleme hesaplandı. Geçerli fiyatlar değiştirilmedi.',
        approvedLocked: 'Bu sürüm onaylıdır. Değişiklik yapmak için senaryoyu kopyalayın.',
        comparison: 'Fiyat karşılaştırması',
        noPreview: 'Henüz önizleme yok. Fiyat ve uyarıları kontrol etmek için senaryoyu hesaplayın.',
        previewSummary: '{{eligible}} ürün aktarılabilir · {{excluded}} hariç',
        comparisonHint: 'Tüm fiyatlar temel birim başına nettir. Yeni koşullar başlangıç gününde kontrol edilir. Gerçek fiyat; kademeleri, müşteri fiyatlarını ve ek müşteri indirimini bir kez, kontrol miktarının belge satırı yuvarlamasıyla birlikte içerir.',
        export: 'Fiyat karşılaştırmasını dışa aktar',
        exportInternal: 'Maliyet ve marjlarla dahili dışa aktar',
        reviewApproval: 'Aktarımı incele',
        article: 'Ürün',
        oldPrice: 'Önceki fiyat',
        basePrice: 'Temel satış fiyatı',
        change: 'Değişiklik',
        actualMargin: 'Gerçek marj',
        excluded: 'Hariç',
        breakdown: 'Hesaplama ve uyarıları aç',
        limitingGroup: 'Asgari marjı sınırlayan grup indirimi',
        actualPrice: 'Müşteri indiriminden sonraki gerçek fiyat',
        conditionSource: 'Geçerli koşul',
        costs: 'Hesaplanan maliyetler',
        difference: 'Hesaplanan maliyetlere fark',
        openEnded: 'Bitiş tarihi yok',
        warning: 'Uyarıyı inceleyin',
        approvalTitle: 'İncelenen fiyat sürümlerini onayla',
        approvalHint: 'Ürünleri, grupları, eski ve yeni fiyatları, geçerliliği ve hariç tutulanları inceleyin. Onaylı fiyatlar sonraki maliyetlerle değişmez.',
        approvalCount: '{{count}} ürünü onayla · {{excluded}} hariç',
        acknowledge: 'Fiyatlar, geçerlilik, uyarılar ve hariç ürünler incelendi',
        approve: 'Fiyat sürümlerini kesin olarak onayla',
        approving: 'Onaylanıyor …',
        approved: 'Fiyat sürümleri onaylandı. Belirlenen dönemde otomatik uygulanır.',
        versions: 'Fiyat sürümleri',
        noVersions: 'Henüz onaylı fiyat sürümü yok.',
        frozenVersion: 'Dondurulmuş onay kaydı. İlk dönemler burada izlenebilir; sonraki onaylar geçerli dönemleri sınırlayabilir.',
        managedPricesHint: 'Onaylı hesaplanan fiyatlar ayrı fiyat sürümleri olarak yönetilir ve buradan kaydederken korunur.',
        origin: {
            GLOBAL: 'Genel varsayılan',
            CATEGORY: 'Fiyat kategorisi',
            PRODUCT: 'Ürün ayarı',
            TEMPLATE: 'Şablon değeri',
            SCENARIO: 'Senaryo istisnası',
            MIXED: 'Farklı devralınan değerler – kendi değerinizi girin',
        },
        states: {
            DRAFT: 'Taslak',
            APPROVED: 'Onaylı',
            PLANNED: 'Planlandı',
            EFFECTIVE: 'Geçerli',
            EXPIRED: 'Süresi doldu / değiştirildi',
        },
        sources: {
            CUSTOMER: 'Müşteriye özel fiyat',
            GROUP: 'Fiyat grubu kademesi',
            GENERAL: 'Genel kademe',
            LIST: 'Liste fiyatı',
        },
        costFields: {
            amount: 'Birim başına net maliyet',
            unitCode: 'Maliyet birimi',
            currency: 'Maliyet para birimi',
            asOf: 'Maliyet tarihi',
            source: 'Kaynak / varsayım gerekçesi',
        },
        errors: {
            invalidInput: 'Adları, ondalık değerleri, temelleri ve zorunlu alanları kontrol edin.',
            costRequired: 'Bilinen maliyetler eksik. Maliyet kaynağı veya açık varsayım ekleyin.',
            unitMismatch: 'Birimler uyuşmuyor. Temel birimi veya mevcut ambalajı açıkça kullanın.',
            currencyMismatch: 'Para birimleri uyuşmuyor. Otomatik dönüşüm yapılmaz.',
            quantityRequired: 'Toplam tutar için uygun hesaplama miktarı eksik.',
            invalidReference: 'Yalnızca etkin bir önceki ara toplam temel alınabilir. Sıralamayı kontrol edin.',
            invalidMargin: 'Hedef marj en az %0 ve %100’ün altında olmalıdır.',
            negativeResult: 'Bir hesaplama adımı negatif maliyet veya fiyat oluşturuyor.',
            overflow: 'Hesaplanan tutar izin verilen fiyat aralığını aşıyor.',
            impossibleMargin: 'Bu indirimlerle asgari marja ulaşılamaz. İndirimleri ve hedef marjı kontrol edin.',
            duplicate: 'Bir anahtar, grup veya kapsam ataması birden fazla kez var.',
            unknownVariable: 'Geçerli şablonda merkezi bir değer eksik. Atamayı veya istisnaları kontrol edin.',
            invalidDate: 'Geçerli bir takvim tarihi girin.',
            invalidScope: 'Kapsam ve atama uyuşmuyor.',
            validity: 'Bitiş tarihi başlangıçtan önce olamaz.',
            groupsRequired: 'En az temel fiyatı veya bir fiyat grubunu seçin.',
            singlePackaging: 'Ambalaj yalnızca tek seçili ürün için kontrol edilebilir.',
            notFound: 'Seçilen şablon, atama veya ana veri başvurusu bulunamadı.',
            inactiveGroup: 'Seçili bir fiyat grubu devre dışı veya henüz incelenmemiş.',
            productReview: 'Bu ürün kullanılmadan önce ticari olarak incelenmelidir.',
            categoryAssignment: 'Seçilen fiyat kategorisi bu ürüne atanmamış.',
            ambiguousCategory: 'Birden çok eşleşen fiyat kategorisi var: üründe birini açıkça seçin.',
            definitionRequired: 'Tam bir hesaplama şablonu yok.',
            groupRuleRequired: 'Seçili fiyat grubu için açık indirim veya artış kuralı eksik.',
            recipeRequired: 'Referans tarihinde onaylı, uygun ve tam bir reçete sürümü seçin.',
            recipePermission: 'Bu maliyet kaynağı ek reçete ve maliyet yetkileri gerektirir.',
            futureCost: 'Maliyet tarihi seçilen referans tarihinden sonra.',
            quantityStep: 'Kontrol miktarı ambalajın asgari miktarına veya adımına uymuyor.',
            overlap: 'Aynı fiyat koşulları çakışıyor. Başlangıcı değiştirin veya değiştirmeyi açıkça seçin.',
            minimumMargin: 'Geçerli koşul asgari marjın altında. Kademeleri, müşteri fiyatlarını ve yuvarlamayı kontrol edin.',
            versionConflict: 'Veriler değişti. Yeniden yükleyip değişikliklerinizi tekrar inceleyin.',
            stalePreview: 'Önizleme güncel değil. Maliyetler, şablon veya koşullar değişti. Yeniden hesaplayın.',
            idempotencyConflict: 'Bu aktarım farklı bilgilerle zaten gerçekleştirildi.',
            incomplete: 'Hesaplama eksik. Bu ürünler geçerli fiyat olarak aktarılamaz.',
            invalidSelection: 'Seçim bu incelenmiş önizlemeyle uyuşmuyor.',
            acknowledgeWarnings: 'Onaydan önce uyarıları açıkça doğrulayın.',
            managedPrice: 'Bu fiyat onaylı bir sürüme ait. Değişiklikleri yeni hesaplama ile onaylayın.',
            managedUnit: 'Onaylı fiyat sürümleri temel birimin yeniden yorumlanmasını engeller.',
            immutableRelease: 'Onaylı hesaplama kaydı değiştirilemez veya silinemez.',
            noProducts: 'Bu seçim için ürün bulunamadı.',
            tooManyProducts: 'Seçim 200 ürünü aşıyor. Filtreleri daraltıp incelenmiş alt kümelerle çalışın.',
            templateRequired: 'Tam bir hesaplama şablonu yok.',
            customerConditionsRequired: 'Müşteri indirimi belirsiz. Bu simülasyondan önce müşteri koşullarını kontrol edin.',
            priceUnresolved: 'Kontrol miktarı, para birimi ve müşteri grubu için geçerli fiyat bulunamıyor. Seçim, kademe ve miktarı kontrol edin.',
        },
        warnings: {
            duplicateCost: 'Bu bileşen başlangıç maliyetlerine zaten dahil olabilir.',
            largeChange: '%30’un üzerinde olağandışı fiyat değişimi. Lütfen inceleyin.',
            materialOnly: 'Reçete değerleri malzeme maliyetlerini içerir. Diğer üretim maliyetlerini açıkça ekleyin ve çift sayımdan kaçının.',
            minimumMargin: 'Geçerli koşul asgari marjın altında. Kademeleri, müşteri fiyatlarını ve yuvarlamayı kontrol edin.',
            oldCost: 'Maliyet verisi 90 günden eski. Onaydan önce güncelliği kontrol edin.',
            overridden: 'Mevcut daha yüksek öncelikli koşul gerçek fiyatı belirliyor.',
            replacesPeriods: 'Aynı koşullar yeni dönem için sınırlandırılacak veya bölünecek.',
            costDateUnknown: 'Bu eski alış fiyatının ayrı maliyet tarihi yok. Ürün güncelleme tarihi gösterilir; güncelliği açıkça kontrol edin.',
            unusedVariable: 'Bu devralınan değer geçerli şablonda kullanılmıyor.',
            periodAdjusted: 'Önceki bitiş tarihi geçmişte. Yeni önerinin o bölümünde henüz bitiş tarihi yok; onaydan önce geçerliliği açıkça kontrol edin.',
            previousZero: 'Önceki fiyat 0. Yüzde değişim hesaplanamaz; yeni fiyatı açıkça kontrol edin.',
        },
        remove: 'Kaldır',
        approvedBy: 'Onaylayan',
        actualValidity: 'Güncel dönem parçaları',
        superseded: 'Tamamen değiştirildi',
        newProposal: 'Yeni öneri hesapla',
        newProposalHint: 'Maliyetler veya hesaplama ayarları değişti. Onaylı fiyatlar korunur; yeni öneri incelenebilir.',
        customerPrice: 'Gerçek müşteri grubu',
        calculatedPrice: 'Hesaplanan öneri fiyatı',
        status: 'İnceleme durumu',
        eligible: 'Aktarılabilir',
        variableScopeHint: 'Tek ürün için devralınan değerler gösterilir. Farklı şablonlarda yalnızca ortak değişkenler sunulur; hesaplama her ürünün kesin değerlerini gösterir.',
        replacedConditions: 'Etkilenen mevcut fiyat koşulları',
        previousPeriod: 'Önceki dönem',
        remainingPeriods: 'Kalan dönemler',
        none: 'Yok',
        discount: 'Kademe indirimi',
        resolvedPrice: 'Geçerli koşul fiyatı',
    },
    fr: {
        title: 'Calcul des prix',
        description: 'Calculez, comparez et approuvez des prix de vente traçables à partir des coûts pour une période définie.',
        help: 'Aide sur les prix',
        builder: 'Constructeur de calcul',
        templates: 'Modèles',
        templatesHint: 'Étapes et règles réutilisables ; les changements ne créent des prix qu’après simulation et approbation.',
        template: 'Modèle de calcul',
        addTemplate: 'Créer un modèle',
        noTemplates: 'Aucun modèle. Créez votre premier modèle de calcul.',
        sampleCost: 'Exemple : coût initial par unité',
        sampleHint: 'Cet exemple n’enregistre ni coûts article ni prix de vente.',
        sampleResult: 'Exemple : prix de vente de base',
        calculationQuantity: 'Quantité de calcul et de contrôle',
        stepLabel: 'Nom de l’étape de calcul',
        addStep: 'Ajouter une étape',
        removeStep: 'Retirer l’étape',
        newStep: 'Nouvelle étape',
        moveUp: 'Monter',
        moveDown: 'Descendre',
        active: 'Actif',
        inactive: 'Inactif',
        operation: 'Majoration ou déduction',
        ADD: 'Majoration',
        SUBTRACT: 'Déduction / remise',
        valueType: 'Type de valeur',
        percent: 'Pourcentage',
        fixed: 'Montant fixe',
        value: 'Valeur',
        basis: 'Base de calcul',
        ORIGINAL: 'Coûts initiaux d’origine',
        SUBTOTAL: 'Sous-total courant',
        STEP: 'Sous-total précédent nommé',
        referenceStep: 'Étape précédente',
        fixedBasis: 'Base du montant fixe',
        perUnit: 'Par unité',
        perBatch: 'Total pour une quantité / un lot',
        fixedQuantity: 'Quantité de calcul fixe',
        fixedQuantityHint: 'Vide : quantité de calcul choisie. 70 € pour 100 unités = 0,70 € par unité.',
        unit: 'Unité',
        unitHint: 'Vide : unité de base de chaque article. Une autre unité exige un conditionnement sélectionné.',
        advanced: 'Paramètres avancés',
        centralVariable: 'Valeur centralisée',
        ownValue: 'Valeur propre à cette étape',
        costComponent: 'Clé du composant de coût',
        costComponentHint: 'Par exemple transport. La même clé dans la source de coût signale un double comptage.',
        of: 'de',
        subtotal: 'Sous-total',
        profitMethod: 'Méthode de bénéfice',
        MARKUP: 'Majoration sur coûts',
        MARGIN: 'Marge cible sur prix de vente net',
        markupExample: '100 € de coûts + 25 % de majoration = 125 € net. La marge est de 20 %.',
        marginExample: '100 € de coûts / (1 − 25 % de marge cible) = 133,3333 € net. La marge doit être inférieure à 100 %.',
        profitPercent: 'Majoration / marge cible en %',
        minimumAfterGroups: 'Atteindre au moins la marge cible après remises de groupe et du client sélectionné',
        variables: 'Valeurs centrales',
        variableKey: 'Clé stable',
        newVariable: 'Nouvelle valeur centrale',
        addVariable: 'Ajouter une valeur centrale',
        name: 'Nom',
        version: 'Version',
        copy: 'Copie',
        saved: 'Enregistré. Les prix effectifs restent inchangés jusqu’à l’approbation.',
        saveError: 'Impossible d’enregistrer la modification. Vos saisies sont conservées.',
        loadError: 'Impossible de charger les données. Réessayez.',
        choose: 'Veuillez sélectionner',
        groupRules: 'Groupes de prix : remises et majorations',
        independentGroups: 'Chaque groupe est calculé indépendamment du prix de base. Les remises ne se cumulent pas entre groupes.',
        productSearch: 'Rechercher des articles',
        selectedProduct: 'Article sélectionné',
        noProducts: 'Aucun article correspondant.',
        customerSearch: 'Rechercher des clients',
        customer: 'Vérifier les conditions client',
        noCustomer: 'Sans remise client supplémentaire',
        overrideHint: 'Seules les dérogations activées remplacent les valeurs héritées.',
        inheritanceHint: 'Priorité à l’article, puis à la catégorie de prix explicitement déterminée, puis aux valeurs globales. Les catégories ambiguës bloquent le calcul.',
        assignments: 'Affectations et valeurs par défaut',
        scope: 'Portée',
        inherit: 'Utiliser la valeur héritée',
        inheritPurchase: 'Hériter ; sinon prix d’achat de l’article',
        priceCategory: 'Catégorie de prix (catégorie article)',
        priceCategoryHint: 'Catégories affectées uniquement. Cette sélection résout explicitement les correspondances multiples.',
        automaticCategory: 'Catégorie affectée unique / principale',
        costSource: 'Source des coûts',
        PRODUCT_PURCHASE: 'Prix d’achat de la fiche article',
        ASSUMPTION: 'Hypothèse de calcul explicite',
        RECIPE_VERSION: 'Version de recette approuvée : coûts matières',
        recipeVersion: 'Version de recette approuvée',
        materialOnly: 'La recette contient les coûts matières. Ajoutez explicitement les autres coûts de fabrication sans double comptage.',
        includedCosts: 'Clés de coûts déjà inclus',
        includedCostsHint: 'Clés séparées par virgules, par exemple material, transport. Les étapes correspondantes signalent le double comptage.',
        valueOverrides: 'Remplacer explicitement les valeurs centrales',
        groupOverrides: 'Remplacer les règles de groupe',
        explicitOverride: 'Utiliser des règles propres à cette portée',
        copyOverrides: 'Copier les dérogations article',
        scenarios: 'Simulation et comparaison',
        scenarioName: 'Nom du scénario',
        simulationHint: 'Les simulations ne changent pas les prix effectifs. Seule l’approbation contrôlée planifie de nouvelles versions.',
        newScenario: 'Nouveau scénario',
        noScenarios: 'Aucun scénario. Sélectionnez des articles et calculez une proposition.',
        selection: 'Sélection d’articles',
        selectedProducts: 'Article unique ou sélection',
        filteredAssortment: 'Assortiment filtré',
        useAssignment: 'Utiliser le modèle affecté / hérité',
        exactCategoryHint: 'Articles de cette catégorie ; les sous-catégories ne sont pas incluses automatiquement.',
        productGroup: 'Groupe d’articles',
        tags: 'Étiquettes (séparées par virgules)',
        referenceDate: 'Date de référence des conditions existantes',
        currency: 'Devise',
        packaging: 'Unité / conditionnement',
        validFrom: 'Valable à partir du',
        validTo: 'Valable jusqu’au (inclus)',
        groupPrices: 'Prix de groupe',
        includeBase: 'Appliquer le prix de base comme condition générale',
        minQuantity: 'Palier à partir de la quantité en unité de base',
        tierHint: '0 couvre aussi les fractions. Les paliers supérieurs et prix client existants restent prioritaires.',
        activeOnly: 'Articles actifs uniquement',
        periodConflicts: 'Traitement des conditions identiques qui se chevauchent',
        periodConflictHint: 'Le remplacement apparaît avant approbation. Les anciennes périodes sont limitées ou divisées ; les prix des documents sont conservés.',
        REJECT: 'Exclure les conflits',
        REPLACE: 'Remplacer explicitement les mêmes conditions sur la nouvelle période',
        profitOverride: 'Modifier l’objectif de bénéfice dans ce scénario uniquement',
        schedule: 'Dates de début et de fin différentes',
        addSchedule: 'Ajouter une période différente',
        group: 'Groupe de prix',
        target: 'Article / catégorie / groupe',
        saveScenario: 'Enregistrer le scénario',
        simulate: 'Calculer et comparer',
        calculating: 'Calcul en cours…',
        simulated: 'Aperçu calculé. Aucun prix effectif n’a été modifié.',
        approvedLocked: 'Cette version est approuvée. Copiez le scénario pour le modifier.',
        comparison: 'Comparaison des prix',
        noPreview: 'Aucun aperçu. Calculez le scénario pour vérifier les prix et les remarques.',
        previewSummary: '{{eligible}} articles admissibles · {{excluded}} exclus',
        comparisonHint: 'Tous les prix sont nets par unité de base. Les nouvelles conditions sont vérifiées à leur date de début. Le prix réel inclut paliers, prix client et remise client supplémentaire une seule fois, avec arrondi de ligne pour la quantité contrôlée.',
        export: 'Exporter la comparaison des prix',
        exportInternal: 'Exporter en interne avec coûts et marges',
        reviewApproval: 'Vérifier l’application',
        article: 'Article',
        oldPrice: 'Ancien prix',
        basePrice: 'Prix de vente de base',
        change: 'Variation',
        actualMargin: 'Marge réelle',
        excluded: 'Exclu',
        breakdown: 'Ouvrir le calcul et les remarques',
        limitingGroup: 'Remise de groupe limitante pour la marge minimale',
        actualPrice: 'Prix réel après remise client',
        conditionSource: 'Condition effective',
        costs: 'Coûts calculés',
        difference: 'Écart aux coûts calculés',
        openEnded: 'Sans date de fin',
        warning: 'Vérifier la remarque',
        approvalTitle: 'Approuver les versions de prix contrôlées',
        approvalHint: 'Vérifiez articles, groupes, anciens et nouveaux prix, validité et exclusions. Les coûts ultérieurs ne modifieront pas les prix approuvés.',
        approvalCount: 'Approuver {{count}} articles · {{excluded}} exclus',
        acknowledge: 'Prix, validité, avertissements et articles exclus vérifiés',
        approve: 'Approuver définitivement les versions de prix',
        approving: 'Approbation en cours…',
        approved: 'Versions approuvées. Elles s’appliquent automatiquement pendant la période définie.',
        versions: 'Versions de prix',
        noVersions: 'Aucune version de prix approuvée.',
        frozenVersion: 'État d’approbation figé. Les périodes initiales restent traçables ; les approbations ultérieures peuvent limiter les périodes effectives.',
        managedPricesHint: 'Les prix calculés approuvés sont gérés séparément en versions et conservés lors de cet enregistrement.',
        origin: {
            GLOBAL: 'Valeur globale',
            CATEGORY: 'Catégorie de prix',
            PRODUCT: 'Dérogation article',
            TEMPLATE: 'Valeur du modèle',
            SCENARIO: 'Dérogation du scénario',
            MIXED: 'Valeurs héritées différentes – saisir une valeur explicite',
        },
        states: {
            DRAFT: 'Brouillon',
            APPROVED: 'Approuvé',
            PLANNED: 'Planifié',
            EFFECTIVE: 'Effectif',
            EXPIRED: 'Expiré / remplacé',
        },
        sources: {
            CUSTOMER: 'Prix spécial client',
            GROUP: 'Palier de groupe',
            GENERAL: 'Palier général',
            LIST: 'Prix catalogue',
        },
        costFields: {
            amount: 'Coût net par unité',
            unitCode: 'Unité de coût',
            currency: 'Devise des coûts',
            asOf: 'Date des coûts',
            source: 'Source / justification de l’hypothèse',
        },
        errors: {
            invalidInput: 'Vérifiez noms, valeurs décimales, bases et champs obligatoires.',
            costRequired: 'Les coûts connus sont incomplets. Ajoutez une source ou une hypothèse explicite.',
            unitMismatch: 'Les unités ne correspondent pas. Utilisez l’unité de base ou un conditionnement existant explicite.',
            currencyMismatch: 'Les devises ne correspondent pas. Aucune conversion automatique.',
            quantityRequired: 'Une quantité de calcul adaptée manque pour le montant total.',
            invalidReference: 'Seul un sous-total précédent actif peut servir de base. Vérifiez l’ordre.',
            invalidMargin: 'La marge cible doit être au moins de 0 % et inférieure à 100 %.',
            negativeResult: 'Une étape produit des coûts ou un prix négatifs.',
            overflow: 'Le montant calculé dépasse la plage de prix autorisée.',
            impossibleMargin: 'La marge minimale est impossible avec ces remises. Vérifiez les remises et la marge cible.',
            duplicate: 'Une clé, un groupe ou une affectation de portée apparaît plusieurs fois.',
            unknownVariable: 'Une valeur centrale manque au modèle effectif. Vérifiez l’affectation ou les dérogations.',
            invalidDate: 'Saisissez une date valide.',
            invalidScope: 'La portée et l’affectation ne correspondent pas.',
            validity: 'La date de fin ne doit pas précéder le début.',
            groupsRequired: 'Sélectionnez au moins le prix de base ou un groupe de prix.',
            singlePackaging: 'Un conditionnement ne peut être contrôlé que pour un article sélectionné seul.',
            notFound: 'Le modèle, l’affectation ou la référence sélectionné est introuvable.',
            inactiveGroup: 'Un groupe de prix sélectionné est inactif ou non vérifié.',
            productReview: 'Cet article nécessite un contrôle commercial avant utilisation.',
            categoryAssignment: 'La catégorie de prix choisie n’est pas affectée à cet article.',
            ambiguousCategory: 'Plusieurs catégories correspondent : sélectionnez-en explicitement une sur l’article.',
            definitionRequired: 'Aucun modèle de calcul complet.',
            groupRuleRequired: 'Un groupe sélectionné n’a pas de règle explicite de remise ou majoration.',
            recipeRequired: 'Sélectionnez une version adaptée, complète et approuvée à la date de référence.',
            recipePermission: 'Cette source exige des droits supplémentaires sur recettes et coûts.',
            futureCost: 'La date des coûts est postérieure à la date de référence.',
            quantityStep: 'La quantité contrôlée ne respecte pas le minimum ou le pas du conditionnement.',
            overlap: 'Des conditions identiques se chevauchent. Changez la date ou choisissez explicitement le remplacement.',
            minimumMargin: 'La condition effective est sous la marge minimale. Vérifiez paliers, prix client et arrondi.',
            versionConflict: 'Les données ont changé. Rechargez et vérifiez à nouveau vos modifications.',
            stalePreview: 'L’aperçu est périmé. Coûts, modèle ou conditions ont changé. Recalculez.',
            idempotencyConflict: 'Cette application a déjà été effectuée avec d’autres données.',
            incomplete: 'Calcul incomplet. Ces articles ne peuvent pas être appliqués comme prix valides.',
            invalidSelection: 'La sélection ne correspond pas à cet aperçu contrôlé.',
            acknowledgeWarnings: 'Confirmez explicitement les remarques et avertissements avant approbation.',
            managedPrice: 'Ce prix appartient à une version approuvée. Approuvez les modifications via un nouveau calcul.',
            managedUnit: 'Les versions approuvées protègent l’unité de base contre toute réinterprétation.',
            immutableRelease: 'Un état de calcul approuvé ne peut être modifié ni supprimé.',
            noProducts: 'Aucun article trouvé pour cette sélection.',
            tooManyProducts: 'La sélection dépasse 200 articles. Réduisez les filtres et travaillez par sous-ensembles contrôlés.',
            templateRequired: 'Aucun modèle de calcul complet.',
            customerConditionsRequired: 'La remise client est indéterminée. Vérifiez les conditions avant cette simulation.',
            priceUnresolved: 'Aucun prix valide pour cette quantité, devise et groupe client. Vérifiez sélection, palier et quantité.',
        },
        warnings: {
            duplicateCost: 'Ce composant peut déjà être inclus dans les coûts initiaux.',
            largeChange: 'Variation inhabituelle supérieure à 30 %. Vérifiez.',
            materialOnly: 'La recette contient les coûts matières. Ajoutez explicitement les autres coûts de fabrication sans double comptage.',
            minimumMargin: 'La condition effective est sous la marge minimale. Vérifiez paliers, prix client et arrondi.',
            oldCost: 'Les coûts datent de plus de 90 jours. Vérifiez avant approbation.',
            overridden: 'Une condition existante prioritaire détermine le prix réel.',
            replacesPeriods: 'Les mêmes conditions seront limitées ou divisées pour la nouvelle période.',
            costDateUnknown: 'Cet ancien prix d’achat n’a pas de date de coût propre. La date de mise à jour article est affichée ; vérifiez explicitement son actualité.',
            unusedVariable: 'Cette valeur héritée n’est pas utilisée par le modèle effectif.',
            periodAdjusted: 'Une ancienne date de fin est passée. Cette partie de la nouvelle proposition n’a pas encore de fin ; vérifiez la validité avant approbation.',
            previousZero: 'L’ancien prix vaut 0. La variation en pourcentage est incalculable ; vérifiez explicitement le nouveau prix.',
        },
        remove: 'Retirer',
        approvedBy: 'Approuvé par',
        actualValidity: 'Fragments de période actuels',
        superseded: 'Entièrement remplacé',
        newProposal: 'Calculer une nouvelle proposition',
        newProposalHint: 'Les coûts ou valeurs de calcul ont changé. Les prix approuvés restent inchangés ; une nouvelle proposition peut être contrôlée.',
        customerPrice: 'Groupe réel du client',
        calculatedPrice: 'Prix proposé calculé',
        status: 'État du contrôle',
        eligible: 'Admissible',
        variableScopeHint: 'Les valeurs héritées sont affichées pour un article. Avec plusieurs modèles, seules les variables communes sont proposées ; le calcul détaille les valeurs par article.',
        replacedConditions: 'Conditions de prix existantes concernées',
        previousPeriod: 'Période précédente',
        remainingPeriods: 'Périodes restantes',
        none: 'Aucun',
        discount: 'Remise de palier',
        resolvedPrice: 'Prix de condition effectif',
    },
    es: {
        title: 'Cálculo de precios',
        description: 'Calcule, compare y apruebe precios de venta trazables a partir de costes para un período definido.',
        help: 'Ayuda de precios',
        builder: 'Constructor de cálculo',
        templates: 'Plantillas',
        templatesHint: 'Pasos y reglas reutilizables; los cambios generan precios solo tras simulación y aprobación.',
        template: 'Plantilla de cálculo',
        addTemplate: 'Crear plantilla',
        noTemplates: 'Aún no hay plantillas. Cree su primera plantilla de cálculo.',
        sampleCost: 'Ejemplo: coste inicial por unidad',
        sampleHint: 'Este ejemplo no guarda costes ni precios de venta.',
        sampleResult: 'Ejemplo: precio de venta base',
        calculationQuantity: 'Cantidad de cálculo y comprobación',
        stepLabel: 'Nombre del paso de cálculo',
        addStep: 'Añadir paso de cálculo',
        removeStep: 'Eliminar paso de cálculo',
        newStep: 'Nuevo paso de cálculo',
        moveUp: 'Subir',
        moveDown: 'Bajar',
        active: 'Activo',
        inactive: 'Inactivo',
        operation: 'Recargo o deducción',
        ADD: 'Recargo',
        SUBTRACT: 'Deducción / descuento',
        valueType: 'Tipo de valor',
        percent: 'Porcentaje',
        fixed: 'Importe fijo',
        value: 'Valor',
        basis: 'Base de cálculo',
        ORIGINAL: 'Costes iniciales originales',
        SUBTOTAL: 'Subtotal actual',
        STEP: 'Subtotal anterior con nombre',
        referenceStep: 'Paso de cálculo anterior',
        fixedBasis: 'Base del importe fijo',
        perUnit: 'Por unidad',
        perBatch: 'Total de una cantidad / lote',
        fixedQuantity: 'Cantidad fija de cálculo',
        fixedQuantityHint: 'Vacío: cantidad de cálculo elegida. 70 € por 100 unidades = 0,70 € por unidad.',
        unit: 'Unidad',
        unitHint: 'Vacío: unidad base de cada artículo. Otra unidad requiere un envase seleccionado expresamente.',
        advanced: 'Ajustes avanzados',
        centralVariable: 'Valor centralizado',
        ownValue: 'Valor propio de este paso',
        costComponent: 'Clave del componente de coste',
        costComponentHint: 'Por ejemplo transport. La misma clave en el origen del coste avisa de un doble cómputo.',
        of: 'de',
        subtotal: 'Subtotal',
        profitMethod: 'Método de beneficio',
        MARKUP: 'Recargo sobre costes',
        MARGIN: 'Margen objetivo sobre precio neto',
        markupExample: '100 € de costes + 25 % de recargo = 125 € netos. El margen es del 20 %.',
        marginExample: '100 € de costes / (1 − 25 % de margen objetivo) = 133,3333 € netos. El margen debe ser inferior al 100 %.',
        profitPercent: 'Recargo / margen objetivo en %',
        minimumAfterGroups: 'Mantener al menos el margen objetivo tras descuentos de grupo y del cliente elegido',
        variables: 'Valores centrales',
        variableKey: 'Clave estable',
        newVariable: 'Nuevo valor central',
        addVariable: 'Añadir valor central',
        name: 'Nombre',
        version: 'Versión',
        copy: 'Copia',
        saved: 'Guardado. Los precios vigentes no cambian hasta su aprobación.',
        saveError: 'No se pudo guardar el cambio. Se conservan sus datos.',
        loadError: 'No se pudieron cargar los datos. Vuelva a intentarlo.',
        choose: 'Seleccione',
        groupRules: 'Grupos de precios: descuentos y recargos',
        independentGroups: 'Cada grupo se calcula independientemente del precio base. Los descuentos de grupos no se encadenan.',
        productSearch: 'Buscar artículos',
        selectedProduct: 'Artículo seleccionado',
        noProducts: 'No hay artículos coincidentes.',
        customerSearch: 'Buscar clientes',
        customer: 'Comprobar condiciones del cliente',
        noCustomer: 'Sin descuento adicional de cliente',
        overrideHint: 'Solo las excepciones activadas sustituyen los valores heredados.',
        inheritanceHint: 'Prioridad al artículo, después a la categoría de precios determinada y finalmente a los valores globales. Las categorías ambiguas bloquean el cálculo.',
        assignments: 'Asignaciones y valores predeterminados',
        scope: 'Ámbito',
        inherit: 'Usar valor heredado',
        inheritPurchase: 'Heredar; en su defecto precio de compra del artículo',
        priceCategory: 'Categoría de precios (categoría de artículos)',
        priceCategoryHint: 'Solo categorías asignadas. Esta selección resuelve expresamente las coincidencias múltiples.',
        automaticCategory: 'Categoría asignada inequívoca / principal',
        costSource: 'Origen de costes',
        PRODUCT_PURCHASE: 'Precio de compra de la ficha del artículo',
        ASSUMPTION: 'Hipótesis de cálculo explícita',
        RECIPE_VERSION: 'Versión de receta aprobada: costes de material',
        recipeVersion: 'Versión de receta aprobada',
        materialOnly: 'La receta contiene costes de material. Añada expresamente los demás costes de fabricación sin duplicarlos.',
        includedCosts: 'Claves de costes ya incluidos',
        includedCostsHint: 'Claves separadas por comas, como material, transport. Los pasos coincidentes avisan de doble cómputo.',
        valueOverrides: 'Sustituir expresamente valores centrales',
        groupOverrides: 'Sustituir reglas de grupos',
        explicitOverride: 'Usar reglas propias para este ámbito',
        copyOverrides: 'Copiar excepciones del artículo',
        scenarios: 'Simulación y comparación',
        scenarioName: 'Nombre del escenario',
        simulationHint: 'Las simulaciones no cambian precios vigentes. Solo la aprobación revisada programa nuevas versiones.',
        newScenario: 'Nuevo escenario',
        noScenarios: 'Aún no hay escenarios. Seleccione artículos y calcule una propuesta.',
        selection: 'Selección de artículos',
        selectedProducts: 'Artículo único o selección',
        filteredAssortment: 'Surtido filtrado',
        useAssignment: 'Usar plantilla asignada / heredada',
        exactCategoryHint: 'Artículos de esta categoría; las subcategorías no se incluyen automáticamente.',
        productGroup: 'Grupo de artículos',
        tags: 'Etiquetas (separadas por comas)',
        referenceDate: 'Fecha de referencia de condiciones actuales',
        currency: 'Moneda',
        packaging: 'Unidad / envase',
        validFrom: 'Válido desde',
        validTo: 'Válido hasta (inclusive)',
        groupPrices: 'Precios de grupo',
        includeBase: 'Aplicar precio base como condición general',
        minQuantity: 'Escala desde cantidad en unidades base',
        tierHint: '0 cubre fracciones. Las escalas superiores y precios de cliente actuales conservan su prioridad.',
        activeOnly: 'Solo artículos activos',
        periodConflicts: 'Tratamiento de condiciones iguales solapadas',
        periodConflictHint: 'La sustitución se muestra antes de aprobar. Los períodos antiguos se limitan o dividen; los precios de documentos se conservan.',
        REJECT: 'Excluir conflictos',
        REPLACE: 'Sustituir expresamente condiciones iguales en el nuevo período',
        profitOverride: 'Cambiar objetivo de beneficio solo en este escenario',
        schedule: 'Fechas de inicio y fin diferentes',
        addSchedule: 'Añadir período diferente',
        group: 'Grupo de precios',
        target: 'Artículo / categoría / grupo',
        saveScenario: 'Guardar escenario',
        simulate: 'Calcular y comparar',
        calculating: 'Calculando…',
        simulated: 'Vista previa calculada. No se modificaron precios vigentes.',
        approvedLocked: 'Esta versión está aprobada. Copie el escenario para modificarlo.',
        comparison: 'Comparación de precios',
        noPreview: 'Aún no hay vista previa. Calcule el escenario para comprobar precios y avisos.',
        previewSummary: '{{eligible}} artículos aptos · {{excluded}} excluidos',
        comparisonHint: 'Todos los precios son netos por unidad base. Las nuevas condiciones se comprueban en su fecha inicial. El precio real incluye escalas, precios de cliente y un único descuento adicional, con redondeo de línea para la cantidad comprobada.',
        export: 'Exportar comparación de precios',
        exportInternal: 'Exportar internamente con costes y márgenes',
        reviewApproval: 'Revisar aplicación',
        article: 'Artículo',
        oldPrice: 'Precio anterior',
        basePrice: 'Precio de venta base',
        change: 'Cambio',
        actualMargin: 'Margen real',
        excluded: 'Excluido',
        breakdown: 'Abrir cálculo y avisos',
        limitingGroup: 'Descuento de grupo limitante del margen mínimo',
        actualPrice: 'Precio real tras descuento del cliente',
        conditionSource: 'Condición efectiva',
        costs: 'Costes calculados',
        difference: 'Diferencia respecto a costes calculados',
        openEnded: 'Sin fecha final',
        warning: 'Revisar aviso',
        approvalTitle: 'Aprobar versiones de precios revisadas',
        approvalHint: 'Revise artículos, grupos, precios antiguos y nuevos, validez y exclusiones. Los costes posteriores no modificarán precios aprobados.',
        approvalCount: 'Aprobar {{count}} artículos · {{excluded}} excluidos',
        acknowledge: 'Precios, validez, advertencias y artículos excluidos revisados',
        approve: 'Aprobar versiones de precios definitivas',
        approving: 'Aprobando…',
        approved: 'Versiones aprobadas. Se aplican automáticamente en el período definido.',
        versions: 'Versiones de precios',
        noVersions: 'Aún no hay versiones de precios aprobadas.',
        frozenVersion: 'Registro de aprobación congelado. Los períodos originales siguen siendo trazables; aprobaciones posteriores pueden limitar su vigencia.',
        managedPricesHint: 'Los precios calculados aprobados se gestionan como versiones separadas y se conservan al guardar aquí.',
        origin: {
            GLOBAL: 'Valor global',
            CATEGORY: 'Categoría de precios',
            PRODUCT: 'Excepción del artículo',
            TEMPLATE: 'Valor de plantilla',
            SCENARIO: 'Excepción del escenario',
            MIXED: 'Valores heredados diferentes: introduzca un valor propio',
        },
        states: {
            DRAFT: 'Borrador',
            APPROVED: 'Aprobado',
            PLANNED: 'Programado',
            EFFECTIVE: 'Vigente',
            EXPIRED: 'Caducado / sustituido',
        },
        sources: {
            CUSTOMER: 'Precio especial del cliente',
            GROUP: 'Escala del grupo',
            GENERAL: 'Escala general',
            LIST: 'Precio de tarifa',
        },
        costFields: {
            amount: 'Coste neto por unidad',
            unitCode: 'Unidad del coste',
            currency: 'Moneda del coste',
            asOf: 'Fecha de costes',
            source: 'Origen / justificación de la hipótesis',
        },
        errors: {
            invalidInput: 'Compruebe nombres, valores decimales, bases y campos obligatorios.',
            costRequired: 'Faltan costes conocidos completos. Añada un origen o una hipótesis explícita.',
            unitMismatch: 'Las unidades no coinciden. Use la unidad base o un envase existente explícito.',
            currencyMismatch: 'Las monedas no coinciden. No hay conversión automática.',
            quantityRequired: 'Falta una cantidad de cálculo adecuada para el importe total.',
            invalidReference: 'Solo puede usarse un subtotal anterior activo. Compruebe el orden.',
            invalidMargin: 'El margen objetivo debe ser al menos 0 % e inferior al 100 %.',
            negativeResult: 'Un paso genera costes o un precio negativos.',
            overflow: 'El importe calculado supera el rango de precios permitido.',
            impossibleMargin: 'El margen mínimo no se puede alcanzar con estos descuentos. Compruebe descuentos y margen.',
            duplicate: 'Una clave, grupo o asignación de ámbito aparece varias veces.',
            unknownVariable: 'Falta un valor central en la plantilla efectiva. Revise asignación o excepciones.',
            invalidDate: 'Introduzca una fecha válida.',
            invalidScope: 'El ámbito y la asignación no coinciden.',
            validity: 'La fecha final no puede preceder a la inicial.',
            groupsRequired: 'Seleccione al menos el precio base o un grupo de precios.',
            singlePackaging: 'Un envase solo puede comprobarse para un artículo seleccionado individualmente.',
            notFound: 'No se encontró la plantilla, asignación o referencia seleccionada.',
            inactiveGroup: 'Un grupo de precios seleccionado está inactivo o sin revisar.',
            productReview: 'Este artículo necesita una revisión comercial antes de usarse.',
            categoryAssignment: 'La categoría de precios elegida no está asignada a este artículo.',
            ambiguousCategory: 'Coinciden varias categorías: seleccione una expresamente en el artículo.',
            definitionRequired: 'No existe una plantilla de cálculo completa.',
            groupRuleRequired: 'Un grupo seleccionado carece de regla explícita de descuento o recargo.',
            recipeRequired: 'Seleccione una receta adecuada, completa y aprobada en la fecha de referencia.',
            recipePermission: 'Este origen requiere permisos adicionales de recetas y costes.',
            futureCost: 'La fecha del coste es posterior a la referencia elegida.',
            quantityStep: 'La cantidad no cumple el mínimo o incremento del envase.',
            overlap: 'Se solapan condiciones iguales. Cambie la fecha inicial o elija expresamente sustituir.',
            minimumMargin: 'La condición efectiva queda bajo el margen mínimo. Revise escalas, precios de cliente y redondeo.',
            versionConflict: 'Los datos han cambiado. Recargue y revise sus cambios.',
            stalePreview: 'La vista previa está obsoleta. Cambiaron costes, plantilla o condiciones. Vuelva a calcular.',
            idempotencyConflict: 'Esta aplicación ya se ejecutó con otros datos.',
            incomplete: 'Cálculo incompleto. Estos artículos no pueden aplicarse como precios válidos.',
            invalidSelection: 'La selección no coincide con esta vista previa revisada.',
            acknowledgeWarnings: 'Confirme expresamente avisos y advertencias antes de aprobar.',
            managedPrice: 'Este precio pertenece a una versión aprobada. Apruebe cambios mediante un nuevo cálculo.',
            managedUnit: 'Las versiones aprobadas protegen la unidad base frente a reinterpretaciones.',
            immutableRelease: 'Un cálculo aprobado no se puede modificar ni eliminar.',
            noProducts: 'No se encontraron artículos para esta selección.',
            tooManyProducts: 'La selección supera 200 artículos. Reduzca filtros y use subconjuntos revisados.',
            templateRequired: 'No existe una plantilla de cálculo completa.',
            customerConditionsRequired: 'El descuento del cliente está sin resolver. Revise sus condiciones antes de simular.',
            priceUnresolved: 'No se puede resolver un precio válido para esta cantidad, moneda y grupo de cliente. Revise selección, escala y cantidad.',
        },
        warnings: {
            duplicateCost: 'Este componente puede estar ya incluido en los costes iniciales.',
            largeChange: 'Cambio inusual superior al 30 %. Revíselo.',
            materialOnly: 'La receta contiene costes de material. Añada expresamente los demás costes de fabricación sin duplicarlos.',
            minimumMargin: 'La condición efectiva queda bajo el margen mínimo. Revise escalas, precios de cliente y redondeo.',
            oldCost: 'Los costes tienen más de 90 días. Compruebe su vigencia antes de aprobar.',
            overridden: 'Una condición existente de mayor prioridad determina el precio real.',
            replacesPeriods: 'Las mismas condiciones se limitarán o dividirán para el nuevo período.',
            costDateUnknown: 'Este precio de compra antiguo no tiene fecha de coste propia. Se muestra la actualización del artículo; compruebe expresamente su vigencia.',
            unusedVariable: 'La plantilla efectiva no utiliza este valor heredado.',
            periodAdjusted: 'Una fecha final anterior ya pasó. Esa parte de la nueva propuesta aún no tiene fecha final; revise expresamente su validez antes de aprobar.',
            previousZero: 'El precio anterior es 0. No se puede calcular el cambio porcentual; revise expresamente el nuevo precio.',
        },
        remove: 'Quitar',
        approvedBy: 'Aprobado por',
        actualValidity: 'Fragmentos de período actuales',
        superseded: 'Sustituido por completo',
        newProposal: 'Calcular una nueva propuesta',
        newProposalHint: 'Cambiaron costes o valores de cálculo. Se conservan los precios aprobados; puede revisar una nueva propuesta.',
        customerPrice: 'Grupo real del cliente',
        calculatedPrice: 'Precio propuesto calculado',
        status: 'Estado de revisión',
        eligible: 'Apto',
        variableScopeHint: 'Se muestran los valores heredados de un artículo. Con distintas plantillas solo se ofrecen variables comunes; el cálculo detalla los valores de cada artículo.',
        replacedConditions: 'Condiciones de precios anteriores afectadas',
        previousPeriod: 'Periodo anterior',
        remainingPeriods: 'Periodos restantes',
        none: 'Ninguno',
        discount: 'Descuento de tramo',
        resolvedPrice: 'Precio de condición efectivo',
    },
};
//# sourceMappingURL=price-calculation.js.map